module.exports = __webpack_public_path__ + "img/icon-searchbar.bc51d5cd.svg";